/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthConfigEntity,
  CreateOrUpdateIdentityProviderDto,
  TenantIdentityProviderEntity,
} from '../models/index';
import {
    AuthConfigEntityFromJSON,
    AuthConfigEntityToJSON,
    CreateOrUpdateIdentityProviderDtoFromJSON,
    CreateOrUpdateIdentityProviderDtoToJSON,
    TenantIdentityProviderEntityFromJSON,
    TenantIdentityProviderEntityToJSON,
} from '../models/index';

export interface CreateOrUpdateAuthConfigsIdentityProviderRequest {
    createOrUpdateIdentityProviderDto: CreateOrUpdateIdentityProviderDto;
}

export interface DeleteAuthConfigsIdentityProviderRequest {
    thirdPartyId: string;
}

export interface GetIdentityProviderRequest {
    thirdPartyId: string;
}

export interface GetIdentityProvidersRequest {
    authTenantId: string;
}

/**
 * 
 */
export class AuthConfigApi extends runtime.BaseAPI {

    /**
     * テナントの認証設定にカスタム認証プロバイダーを登録・更新する。
     */
    async createOrUpdateAuthConfigsIdentityProviderRaw(requestParameters: CreateOrUpdateAuthConfigsIdentityProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createOrUpdateIdentityProviderDto'] == null) {
            throw new runtime.RequiredError(
                'createOrUpdateIdentityProviderDto',
                'Required parameter "createOrUpdateIdentityProviderDto" was null or undefined when calling createOrUpdateAuthConfigsIdentityProvider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/authConfig/identityProviders`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateIdentityProviderDtoToJSON(requestParameters['createOrUpdateIdentityProviderDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * テナントの認証設定にカスタム認証プロバイダーを登録・更新する。
     */
    async createOrUpdateAuthConfigsIdentityProvider(requestParameters: CreateOrUpdateAuthConfigsIdentityProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createOrUpdateAuthConfigsIdentityProviderRaw(requestParameters, initOverrides);
    }

    /**
     * テナントの認証設定から指定したカスタム認証プロバイダーを削除する。
     */
    async deleteAuthConfigsIdentityProviderRaw(requestParameters: DeleteAuthConfigsIdentityProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['thirdPartyId'] == null) {
            throw new runtime.RequiredError(
                'thirdPartyId',
                'Required parameter "thirdPartyId" was null or undefined when calling deleteAuthConfigsIdentityProvider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/authConfig/identityProviders/{thirdPartyId}`.replace(`{${"thirdPartyId"}}`, encodeURIComponent(String(requestParameters['thirdPartyId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * テナントの認証設定から指定したカスタム認証プロバイダーを削除する。
     */
    async deleteAuthConfigsIdentityProvider(requestParameters: DeleteAuthConfigsIdentityProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAuthConfigsIdentityProviderRaw(requestParameters, initOverrides);
    }

    /**
     * テナントの認証設定情報を取得する。
     */
    async getAuthConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthConfigEntity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/authConfig`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthConfigEntityFromJSON(jsonValue));
    }

    /**
     * テナントの認証設定情報を取得する。
     */
    async getAuthConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthConfigEntity> {
        const response = await this.getAuthConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     * テナントの認証設定から指定したカスタム認証プロバイダーを返却する。
     */
    async getIdentityProviderRaw(requestParameters: GetIdentityProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['thirdPartyId'] == null) {
            throw new runtime.RequiredError(
                'thirdPartyId',
                'Required parameter "thirdPartyId" was null or undefined when calling getIdentityProvider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/authConfig/identityProviders/{thirdPartyId}`.replace(`{${"thirdPartyId"}}`, encodeURIComponent(String(requestParameters['thirdPartyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * テナントの認証設定から指定したカスタム認証プロバイダーを返却する。
     */
    async getIdentityProvider(requestParameters: GetIdentityProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getIdentityProviderRaw(requestParameters, initOverrides);
    }

    /**
     * テナントの認証プロバイダー情報を取得する。
     */
    async getIdentityProvidersRaw(requestParameters: GetIdentityProvidersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TenantIdentityProviderEntity>>> {
        if (requestParameters['authTenantId'] == null) {
            throw new runtime.RequiredError(
                'authTenantId',
                'Required parameter "authTenantId" was null or undefined when calling getIdentityProviders().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['authTenantId'] != null) {
            queryParameters['authTenantId'] = requestParameters['authTenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/authConfig/identityProviders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TenantIdentityProviderEntityFromJSON));
    }

    /**
     * テナントの認証プロバイダー情報を取得する。
     */
    async getIdentityProviders(requestParameters: GetIdentityProvidersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TenantIdentityProviderEntity>> {
        const response = await this.getIdentityProvidersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
